import { MyAccountHeaderCombinedProps } from './types';

const usePresenter = (props: MyAccountHeaderCombinedProps): MyAccountHeaderCombinedProps => {
  return props;
};

export default usePresenter;
